import React, { useEffect } from "react";
import "../SnackBar/SnackBar.css";

interface SnackBarProps {
  message: string;
  type?: "success" | "error" | "warning" | "info";
  visible: boolean;
  onClose: () => void;
  duration?: number;
}

const SnackBar: React.FC<SnackBarProps> = ({
  message,
  type = "success",
  visible,
  onClose,
  duration = 3000,
}) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [visible, duration, onClose]);

  return (
    <div id="snackbar" className={`${visible ? "show" : ""} ${type}`}>
      {message}
    </div>
  );
};

export default SnackBar;
